<template>
  <div id="app">
    <theHeader></theHeader>
    <div class="main-wrap">
      <router-view></router-view>
      <div class="button-wrap">
        <div
          :class="isDisplay ? 'contype active' : 'contype'"
          @mouseover="isDisplay = true"
          @mouseleave="isDisplay = false"
        >
          <i class="iconfont icon-liaotian icon" style="font-size: 27px;"></i>
          <p>联系我们</p>
        </div>
        <div class="backtop" v-if="backTop" @click="back">
          <i class="iconfont icon-zhiding icon" style="font-size: 20px;"></i>
        </div>
        <div
          :class="isDisplay ? 'window display' : 'window'"
          @mouseover="isDisplay = true"
          @mouseleave="isDisplay = false"
        >
          <div class="inner">
            <div class="top">
              <i
                class="iconfont icon-zaixianzixun"
                style="font-size: 33px;"
              ></i>
              <a
                href="https://url.cn/5uJjXZG?_type=wpa&qidian=true"
                target="_blank"
                rel="nofollow"
                >在线咨询</a
              >
            </div>
            <div class="bot">
              <div class="bot-top">
                <i
                  class="iconfont icon-dianhuazixun"
                  style="font-size: 26px;"
                ></i>
                <span>电话咨询</span>
              </div>
              <p>400-8835-999</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <theFooter></theFooter>
    <div class="qrcode" v-if="showQrcode" @click="switchQrcode">
      <div class="qrcodebox">
        <img src="../assets/mobel/home/qrcode.jpg" class="qrcode-img"></img>
        <p class="text">
          截图保存二维码到相册
        </p>
        <p class="text">识别关注网银互联公众号</p>
      </div>
    </div>
  </div>
</template>
<script>
import theHeader from "@/components/header";
import theFooter from "@/components/footer";
import theForm from "@/components/form"
import si from "webawesome/libs/utils/tools/slideToTop";
export default {
  components: { theHeader, theFooter, theForm },
  data() {
    return {
      isDisplay: false,
      showQrcode: false,
      footerHeight: undefined,
      mainHeight: undefined,
      windowHeight: undefined,
      foot: false,
      menu: false,
      backTop: false,
      varstyle: "",
      varstylee: "",
    };
  },
  mounted() {
    setTimeout(() => {
      this.foot = true;
    }, 400);
    this.windowHeight = window.screen.availHeight;
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    back() {
      si();
    },
    footerClass() {
      if (this.windowHeight && this.mainHeight && this.footerHeight) {
        if (this.windowHeight > this.mainHeight + this.footerHeight) {
          return "absoluteF";
        }
      }
    },
    hoverLi(key) {
      if (key == 0) {
        this.varstyle = "width:220px;";
      } else {
        this.varstylee = "width:220px;";
      }
    },
    outLi(key) {
      if (key == 0) {
        this.varstyle = "width:50px";
      } else {
        this.varstylee = "width:50px";
      }
    },
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 400) {
        this.backTop = true;
      } else {
        this.backTop = false;
      }
    },
    footShow() {
      if (this.$route.name)
        return this.foot && this.$route.path.indexOf("mail") < 0;
    },
    openForm(data) {
      this.$refs.theForm.open(data);
    },
    switchQrcode() {
      this.showQrcode = !this.showQrcode
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  watch: {}
};
</script>
<style lang="less" scoped>
@import "../style/variable.less";
@media screen and(min-width:@sm_min) {
  #app {
    cursor: default;
    position: relative;
    .main-wrap {
      position: relative;
      .button-wrap {
        width: 50px;
        height: 150px;
        position: fixed;
        right: 20px;
        bottom: 13%;
        z-index: 99;
      }
      .contype {
        width: 50px;
        height: 155px;
        color: #c3191f;
        cursor: pointer;
        text-align: center;
        font-size: 18px;
        padding-top: 18px;
        border-radius: 2px;
        background-color: #fff;
        transition: all 0.3s;
        border: 1px solid rgba(195, 25, 31, 1);
        p {
          padding-top: 8px;
          padding-left: 16px;
          text-align: center;
          width: 20px;
        }
        &:hover {
          color: #fff;
          border: none;
          background: linear-gradient(
            90deg,
            rgba(192, 25, 32, 1),
            rgba(233, 83, 27, 1)
          );
        }
      }
      .active {
        color: #fff;
        border: none;
        background: linear-gradient(
          90deg,
          rgba(192, 25, 32, 1),
          rgba(233, 83, 27, 1)
        );
      }
      .backtop {
        padding-top: 6px;
        margin-top: 20px;
        cursor: pointer;
        text-align: center;
        width: 50px;
        height: 40px;
        color: #c3191f;
        border-radius: 2px;
        background: #fff;
        border: 1px solid rgba(195, 25, 31, 1);
        &:hover {
          color: #fff;
          border: none;
          background: linear-gradient(
            90deg,
            rgba(192, 25, 32, 1),
            rgba(233, 83, 27, 1)
          );
        }
      }
      .window {
        display: none;
        width: 160px;
        height: 155px;
        position: absolute;
        top: 0;
        left: -160px;
        .inner {
          background: #fff;
          border: 1px solid rgba(193, 193, 193, 1);
          width: 150px;
        }
        .top,
        .bot-top {
          color: #3b3435;
          font-size: 16px;
          display: -webkit-flex; /* Safari */
          display: flex;
          align-items: center;
          justify-content: center;
          i {
            margin-right: 10px;
          }
        }
        .top {
          height: 60px;
          // cursor: pointer;
          &:hover {
            a {
              color: #c5201f;
            }
            color: #c5201f;
            background: rgba(197, 32, 31, 0.1);
          }
        }
        .bot {
          padding: 20px 0 0 0;
          text-align: center;
          flex-wrap: wrap;
          height: 95px;
          p {
            margin-top: 10px;
            color: #666;
          }
          &:hover {
            .bot-top {
              color: #c5201f;
            }
            p {
              color: #c5201f;
            }
            background: rgba(197, 32, 31, 0.1);
          }
        }
      }
      .display {
        display: block;
      }
    }
  }
}
@media screen and (min-width: @phone) and (max-width: @xs) {
  #app {
    position: relative;
    overflow: hidden;
    .main-wrap {
      .button-wrap {
        display: none;
      }
    }
    .qrcode {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 999;
      background: rgba(0, 0, 0, 0.3);
      .qrcodebox {
        width: 8rem;
        height: 9rem;
        background: #fff;
        border-radius: 5px;
        padding: 1rem 1rem 0;
        position: fixed;
        bottom: 7rem;
        left: 50%;
        transform: translateX(-50%);
        text-align: center;
        .qrcode-img {
          width: 6rem;
          height: 6rem;
          background: #ccc;
          margin-bottom: 0.5rem;
        }
        .text {
          color: #666;
          font-size: 0.38rem;
          line-height: 0.5rem;
        }
      }
    }
  }
}
</style>
<style lang="less">
.clearfix:after {
  centent: ""; //设置内容为空
  height: 0; //高度为0
  line-height: 0; //行高为0
  display: block; //将文本转为块级元素
  visibility: hidden; //将元素隐藏
  clear: both//清除浮动;
}
.clearfix {
  zoom: 1; //为了兼容IE
}
</style>



// WEBPACK FOOTER //
// src/view/main.vue